/*
  public int Jobf_JobIdentity { get; set; }
  public string Jobf_JobId { get; set; }
  public string Jobf_JobDescription { get; set; }
 */
export class JobFile {
  Jobf_JobIdentity: number;
  Jobf_JobId: string;
  Jobf_JobDescription: string;
  Jobf_CallersName: string;
  Jobf_CallersPhoneNo: string;
  Jobf_CallersWorkPhoneNo: string;
  Jobf_CallersMobileNo: string;
}
